import script from "./OffCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./OffCanvas.vue?vue&type=script&setup=true&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=36765cc7&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/50sunset/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36765cc7"]])

export default __exports__